import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getEmployeesAssetsReportPagination = (state) =>
  get(state, 'reports.employeesAssets.pagination', {});

export const getEmployeesAssetsReportFilters = (state) =>
  get(state, 'reports.employeesAssets.filters', {});

export const getEmployeesAssetsReportNeedFetch = (state) =>
  get(state, 'reports.employeesAssets.needFetch', false);

export const getEmployeesAssetsReportIsLoading = (state) =>
  get(state, 'reports.employeesAssets.isLoading', false);

export const getEmployeesAssetsReportRecords = (state) =>
  get(state, 'reports.employeesAssets.entities.assets', {});
export const getEmployeesAssetsReportRecordsIds = (state) =>
  get(state, 'reports.employeesAssets.result.assets', []);

export const getEmployeesAssetsReportVisibleRecords = createSelector(
  [getEmployeesAssetsReportRecordsIds, getEmployeesAssetsReportRecords],
  (ids, assets) => ids.map((id) => assets[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/selectors/employees_assets_report_selectors.js